export const defaultMaxLogEntriesCount = 5000;
export const defaultResourceNamePrefix = '//enginemanager.h2o.ai/';
